import React from 'react';
import { Box, Stack, Typography, alpha } from '@mui/material';
import { getAccentColor, getBodyColor } from './shared';

const NewsHighlightsSection = ({
  section, sectionKey, sectionIndex, profiles, columns, profileImageObjectPosition,
  renderHtmlTextBlock, renderPositionableElement,
}) => {
  const accent = getAccentColor(section) || '#4F46E5';
  const bodyColor = getBodyColor(section) || '#64748B';
  const safeColumns = Math.max(1, Math.min(columns || 3, 3));

  return (
    <Box component="section" sx={{ py: { xs: 1, md: 1.6 } }}>
      <Stack spacing={4} sx={{ width: '100%' }}>
        {(section.title || section.body) && (
          <Stack spacing={1.5} sx={{ textAlign: section.textAlign || 'left' }}>
            {section.title && (
              <Typography component="h2" sx={{ color: '#0F172A', fontWeight: 800, fontSize: { xs: '2rem', md: '2.5rem' }, letterSpacing: '-0.02em', lineHeight: 1.1 }}>
                {section.title}
              </Typography>
            )}
            {section.body && renderPositionableElement({
              section, index: sectionIndex, elementKey: `${sectionKey}-intro`,
              children: renderHtmlTextBlock(section.body, { color: bodyColor, lineHeight: 1.7, fontSize: '1.1rem' }),
            })}
          </Stack>
        )}
        
        <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: { xs: '1fr', sm: `repeat(${Math.min(2, safeColumns)}, 1fr)`, md: `repeat(${safeColumns}, 1fr)` } }}>
          {profiles.length ? profiles.map((story, index) => (
            <Box key={`${sectionKey}-news-${index}`}>
              {renderPositionableElement({
                section, index: sectionIndex, elementKey: `${sectionKey}-news-${index}`,
                children: (
                  <Box sx={{ 
                    height: '100%', p: 3, borderRadius: '32px', backgroundColor: '#FFFFFF',
                    border: `1px solid ${alpha('#0F172A', 0.06)}`,
                    boxShadow: `0 4px 20px ${alpha('#0F172A', 0.03)}`,
                    transition: 'all 0.3s ease',
                    '&:hover': { transform: 'translateY(-6px)', boxShadow: `0 12px 30px ${alpha(accent, 0.08)}`, borderColor: alpha(accent, 0.2) }
                  }}>
                    <Stack spacing={2.5}>
                      {story.image && (
                        <Box sx={{ width: '100%', aspectRatio: '4/3', borderRadius: '6px', overflow: 'hidden' }}>
                          <Box component="img" src={story.image} alt={story.name || ''} sx={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: profileImageObjectPosition || 'center' }} />
                        </Box>
                      )}
                      <Box>
                        {story.role && (
                          <Typography sx={{ display: 'inline-block', px: 1.5, py: 0.5, mb: 1.5, borderRadius: '6px', backgroundColor: alpha(accent, 0.1), color: accent, fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            {story.role}
                          </Typography>
                        )}
                        <Typography sx={{ color: '#0F172A', fontWeight: 800, fontSize: '1.25rem', mb: 1 }}>{story.name || ''}</Typography>
                        {story.bio && <Typography sx={{ color: '#475569', fontSize: '0.95rem', lineHeight: 1.6 }}>{story.bio}</Typography>}
                      </Box>
                    </Stack>
                  </Box>
                ),
              })}
            </Box>
          )) : (
            <Box sx={{ gridColumn: '1/-1', py: 6, textAlign: 'center', border: '2px dashed #CBD5E1', borderRadius: '32px', backgroundColor: '#F8FAFC' }}>
              <Typography sx={{ color: '#64748B', fontWeight: 600 }}>Add news items in the editor.</Typography>
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  );
};
export default NewsHighlightsSection;
